import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AvailableLanguages } from '@constants';
import { TranslateUtilsService } from '@core/services/translate-utils.service';
import { CreateSupportMessageOpts, SupportChatInList } from '@interfaces';
import { TranslateService } from '@ngx-translate/core';
import { CommonsFacade } from '@state/commons';
import { SupportChatFacade } from '@state/support-chat';
import { NzMessageService } from 'ng-zorro-antd/message';
import { ReplaySubject, take, takeUntil } from 'rxjs';

@Component({
  selector: 'app-follow-up-chat-modal',
  templateUrl: './follow-up-chat-modal.component.html',
  styleUrls: ['./follow-up-chat-modal.component.scss'],
})
export class FollowUpChatModalComponent implements OnInit {
  private destroy$: ReplaySubject<boolean> = new ReplaySubject(1);
  private followUpTextByLang: { [key: string]: string } = {};

  public languages$ = this.commonsFacade.availableLanguages$;
  public selectedLang: AvailableLanguages;

  public chatID: string;
  public dialogMessage: string;

  constructor(
    public dialogRef: MatDialogRef<FollowUpChatModalComponent>,
    private readonly supportChatFacade: SupportChatFacade,
    private readonly commonsFacade: CommonsFacade,
    private readonly translateUtilsService: TranslateUtilsService,
    private readonly translateService: TranslateService,
    private readonly nzMessage: NzMessageService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      supportChat: SupportChatInList;
    }
  ) {}

  public async ngOnInit(): Promise<void> {
    await this.translateUtilsService.saveNamespaceTranslations('management', 'MANAGEMENT.FOLLOW_UP');
    this.chatID = this.data.supportChat.id;
    this.followUpTextByLang = this.translateUtilsService.getTranslations('FOLLOW_UP_TEXT_CHAT');
    this.selectedLang = 'en';
    this.onChangeLanguage(this.selectedLang);
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  onChangeLanguage(language: AvailableLanguages): void {
    this.dialogMessage = this.followUpTextByLang[language];
  }

  sendMessege(content: string): void {
    const opts: CreateSupportMessageOpts = {
      content,
      supportChatId: this.chatID,
      attachments: [],
    };

    this.supportChatFacade.createSupportMessageSuccess$.pipe(take(1), takeUntil(this.destroy$)).subscribe(() => {
      this.nzMessage.success(
        this.translateService.instant('MANAGEMENT.FOLLOW_UP.FOLLOW_UP_SUCCESS', {
          username: this.data.supportChat.supportedUser.name,
        })
      );
      this.closeDialog();
    });

    this.supportChatFacade.createSupportMessage(opts);
  }
}
